import { render, staticRenderFns } from "./InPage.vue?vue&type=template&id=7060a83e&scoped=true"
import script from "./InPage.vue?vue&type=script&lang=js"
export * from "./InPage.vue?vue&type=script&lang=js"
import style0 from "./InPage.vue?vue&type=style&index=0&id=7060a83e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7060a83e",
  null
  
)

export default component.exports